import React from 'react'

// material ui
import FormLabel from '@mui/material/FormLabel'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'

// components
import FormControlWithErrorHelper from 'components/shared/FormControlWithErrorHelper'

const RegionInputUS = props => {
  const { onChangeFormField, states, form, formErrors } = props

  return (
    <FormControlWithErrorHelper
      required
      errorsObject={formErrors}
      errorField='region'
    >
      <FormLabel htmlFor='region'>State</FormLabel>
      <Select
        id='region'
        value={form.region}
        onChange={onChangeFormField('region')}
        variant='outlined'
        displayEmpty
        fullWidth
        name='region'
        inputProps={{
          name: 'region',
          id: 'region'
        }}
      >
        {states.map(({ id, name, alpha2 }) => (
          <MenuItem key={id} value={alpha2}>
            {name}
          </MenuItem>
        ))}
      </Select>
    </FormControlWithErrorHelper>
  )
}

export default RegionInputUS
